import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { VoyageStyle, StyleName } from '../../voyage-style/src/voyage-style';

@customElement('voy-theme-menu')
export class VoyThemeMenu extends LitElement
{
    @property({type: Number}) top: number = 0;
    @property({type: Number}) right: number = 0;

    static get styles()
    {
        return [
            css`
            :host {
                position: absolute;
                top: 0;
                right: 0;
            }

            .container {
                padding: 15px;
                border: 1px solid var(--neutrals-grey-07, grey);
                border-radius: 3px;
                box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
                background-color: var(--neutrals-grey-10, white);
            }

            .entry {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .entry > * {
                cursor: pointer;
            }

            input[type="radio"] {
                border-radius: 8px;
                position: relative;
                box-sizing: border-box;
                width: 16px;
                height: 16px;
                appearance: none;
                -webkit-appearance: none;
                border: 1px solid var(--neutrals-grey-06, grey);
                background: none;
            }

            input[type="radio"]:checked::after {
                content: "";
                display: block;
                position: absolute;
                width: 10px;
                height: 10px;
                top: 2px;
                left: 2px;
                border-radius: 5px;
                background-color: var(--primary-blue-05, blue);
            }

            label {
                padding-left: 5px;
                font-family: MaerskText;
                font-size: 14px;
                color: var(--neutrals-grey-03, black);
            }
            `
        ];
    }

    constructor()
    {
        super();
        
        this._onClickOutside = this._onClickOutside.bind(this);
    }

    connectedCallback()
    {
        super.connectedCallback();

        this._selectedTheme = VoyageStyle.currentStyle;

        // Note: Waiting for initial click event to fully propagate before setting up event listener
        setTimeout( () => document.body.addEventListener('click', this._onClickOutside) );
    }

    disconnectedCallback()
    {
        super.disconnectedCallback();

        document.body.removeEventListener('click', this._onClickOutside);
    }

    render()
    {
        this.style.top = this.top + "px";
        this.style.right = this.right + "px";

        return html`
        <div class="container" @click=${ (evt: Event) => evt.stopPropagation() }>
            <div class="entry">
                <input type="radio" id="day" name="theme" .checked=${this._selectedTheme === StyleName.default} @input=${() => this._entryClicked()}>
                <label for="day">Day</label>
            </div>
            <div class="entry">
                <input type="radio" id="dusk" name="theme" .checked=${this._selectedTheme === StyleName.dusk} @input=${() => this._entryClicked()}>
                <label for="dusk">Dusk</label>
            </div>
            <div class="entry">
                <input type="radio" id="night" name="theme" .checked=${this._selectedTheme === StyleName.night} @input=${() => this._entryClicked()}>
                <label for="night">Night</label>
            </div>
        <div>`;
    }

    @property({attribute: false}) private _selectedTheme: StyleName = StyleName.default;

    private _entryClicked(): void
    {
        const stylesMapping: StyleName[] = [ StyleName.default, StyleName.dusk, StyleName.night ];
        const radioButtons = this.shadowRoot!.querySelectorAll('input');

        // Apply new theme selection
        let selectedTheme: StyleName;
        for (let i = 0; i < radioButtons.length; i++)
        {
            if (radioButtons[i].checked)
            {
                selectedTheme = stylesMapping[i];
                break;
            }
        }
        VoyageStyle.applyGlobalStyles(selectedTheme!);

        this.dispatchEvent(new Event('close'));
        this.remove();
    }

    private _onClickOutside(): void
    {
        this.dispatchEvent(new Event('close'));
        this.remove();
    }
};
